import $ from "jquery";
import "../../../../lib/slick.min";


export default function setCarouselAnimation(){
	$(".crslItems").slick({
		infinite:true
		,autoplay:true
		,autoplaySpeed:4500 // msec
		,speed:600
		,swipe:true
		,dots:true
		,dotsClass:"crslNavItems"
		,arrows:false
	});
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/carousel.js